document.addEventListener('DOMContentLoaded', () => {
    const handleSeoFaqGenerator = () => {
        const faqData = [];

    const extractFAQData = (details) => {
        details.forEach( (detail) => {
            const title = detail.querySelector('summary h3').textContent.trim();
            const answerContents = detail.querySelector('.section-faq__container__main-content__faq-box__question-wrapper__faq-answer').querySelectorAll('p, ul, ol');
            const descriptionWithParagraph = createDescriptionWithParagraph(answerContents);
            faqData.push({
                title: title,
                description: descriptionWithParagraph
            });
        });
    }


    const createDescriptionWithParagraph = (answerContents) => {
        let descriptionWithParagraph = '';
        answerContents.forEach( (content) => {
        const description = content.textContent.trim().replace(/\n\s+/g, '');
        const paragraph = document.createElement('p');
        paragraph.textContent = description;
        descriptionWithParagraph += paragraph.outerHTML;
    });
    return descriptionWithParagraph;
}
  
    const FAQ_ANSWER_ELEMENTS_ARRAY = document.querySelectorAll('.section-faq__container__main-content__faq-box__question-wrapper');

    extractFAQData(FAQ_ANSWER_ELEMENTS_ARRAY);
  
    const structuredDataElement = document.querySelector('script[type="application/ld+json"]');
    const structuredJsonData = JSON.parse(structuredDataElement.textContent);
  
    structuredJsonData["@graph"].forEach( (item) => {
        if (item["@type"] === "FAQPage") {
            faqData.forEach( (faqItem) => {
                const newQuestion = {
                    "@type": "Question",
                    "name": faqItem.title,
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": faqItem.description
                    }
                };
                if (!item.mainEntity) {
                    item.mainEntity = [];
                }
                item.mainEntity.push(newQuestion);
            });
        }
    });
  
    structuredDataElement.textContent = JSON.stringify(structuredJsonData);
  }
  handleSeoFaqGenerator()
  
});